import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { deleteUserTrackingWalletRequestAction } from './wallet-tracker-requests'

import type { WalletAddress } from '@root/entities/wallet'

export const reatomDeleteWalletTracking = ({
  walletAddress,
}: {
  walletAddress: WalletAddress
}) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const requestState = reatomRequest({
    execAction: deleteUserTrackingWalletRequestAction,
    prepare: (ctx) => ({
      network: ctx.get(selectedNetworkAtom),
      walletAddress,
    }),
    onResult: (ctx, result) => {
      if (Result.isFailure(result)) {
        showErrorSnackbarAction(ctx, result.failure)
        return
      }
      showSnackbarAction(ctx, {
        text: i18next.t('wallet-tracker.delete-wallet.success'),
        intent: 'success',
      })
      walletTrackingDeletedEvent(ctx, { walletAddress })
    },
  })

  return requestState
}

// eslint-disable-next-line @reatom/unit-naming-rule
export const walletTrackingDeletedEvent = action<{
  walletAddress: WalletAddress
}>('walletTrackingDeletedEvent')
